module.exports = __webpack_public_path__ + "media/images/front/sp/treatment-introduction-article/img01-3c804809a452524221821dc32c95f481.png";